import { render, staticRenderFns } from "./batch_shelf_channel_dialog.vue?vue&type=template&id=5255c97c&scoped=true"
import script from "./batch_shelf_channel_dialog.vue?vue&type=script&lang=js"
export * from "./batch_shelf_channel_dialog.vue?vue&type=script&lang=js"
import style0 from "./batch_shelf_channel_dialog.vue?vue&type=style&index=0&id=5255c97c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5255c97c",
  null
  
)

export default component.exports